/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserTherapistProfile } from './userTherapistProfile';
import { RoleEnum } from './roleEnum';
import { UserAppointmentResource } from './userAppointmentResource';
import { UserPatientOpsProfile } from './userPatientOpsProfile';
import { EditableFieldsEnum } from './editableFieldsEnum';
import { GenderEnum } from './genderEnum';
import { UserGroup } from './userGroup';
import { UserPermission } from './userPermission';


/**
 * User detail of the users tab. Each profile section is ``null`` when the user has no such profile.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface UserDetail { 
    readonly id: number;
    readonly email: string;
    readonly name: string;
    readonly gender: GenderEnum;
    readonly role: RoleEnum;
    readonly groups: Array<UserGroup>;
    readonly userPermissions: Array<UserPermission>;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    readonly isActive: boolean;
    readonly lastLogin: string | null;
    readonly dateJoined: string;
    readonly therapistProfile: UserTherapistProfile | null;
    readonly appointmentResource: UserAppointmentResource | null;
    readonly patientOpsProfile: UserPatientOpsProfile | null;
    readonly photoUrl: string | null;
    readonly editableFields: Array<EditableFieldsEnum>;
}
export namespace UserDetail {
}

export const UserDetail_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.email,];

export const UserDetail_name_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_gender_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_role_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_groups_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_userPermissions_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_isActive_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_lastLogin_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_dateJoined_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_therapistProfile_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_appointmentResource_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_patientOpsProfile_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_photoUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserDetail_editableFields_Validators: ValidatorFn[] =
    [  Validators.required, ];


